import { render, staticRenderFns } from "./SelectMunicipality.vue?vue&type=template&id=61c86b8a"
import script from "./SelectMunicipality.vue?vue&type=script&lang=js"
export * from "./SelectMunicipality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports